export const CONTACTS = `
  query contactList(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: ContactOrderInput
    $filter: ContactFilterInput
    $searchText: String
  ) {
    contactList(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Contact {
        id
        firstname
        lastname
        zoho_id
        email
        secondary_email
        phone
        mobile
        city
        country
        country_code
        province
        plaza
        identification
        identification_type_id
        birth_date
        gender
        exclude
        comments
        zip_code
        address
        company_id
        position
        company {
          id
          name
          cuit
          province_id
          city
        }
        its
        uts
        staff {
          id
        }
        member {
          id
        }
        chair {
          id
        }
        exhibitor {
          id
        }
        prospect {
          id
          chair_id
          chair {
            id
            contact {
              firstname
              lastname
            }
          }
        }
        last_chair_id
        last_chair_name
        contact_contact_status {
          id
          status_id
          contact_type
          end_date
          status {
            id
            name
            hex_color
          }
        }
      } 
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CONTACT_COMPANY_DETAILS = `
  query contactCompanyDetails($tenant_id: Int!, $contact_id: Int!) {
    contactCompanyDetails(tenant_id: $tenant_id, contact_id: $contact_id) {
      __typename
      ... on ContactCompanyDetails {
        phone
        employees
        income_name
        contacts { id firstname lastname position chair_name }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const GET_CONTACT = `
  query getContact($id: Int!, $tenant_id: Int!) {
    getContact(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Contact {
        id
        firstname
        lastname
        email
        secondary_email
        phone
        mobile
        city
        country
        country_code
        province
        plaza
        identification
        identification_type_id
        birth_date
        gender
        exclude
        timezone
        zoho_id
        comments
        zip_code
        address
        position
        company_id
        company {
          id
          name
          fantasy_name
          cuit
          phone
          website
          city
          province_id
        }
        its
        uts
        contact_contact_status {
          id
          status_id
          contact_type
          end_date
          status {
            id
            name
            hex_color
          }
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EX_MEMBERS_BY_CHAIR = `
  query exMembersByChair($tenant_id: Int!, $chair_id: Int!) {
    exMembersByChair(tenant_id: $tenant_id, chair_id: $chair_id) {
      __typename
      ... on Contact {
        id
        firstname
        lastname
        email
        company {
          id
          name
          cuit
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CONTACTS_COUNT = `
  query contactsCount(
    $tenant_id: Int!
    $orderBy: ContactOrderInput
    $filter: ContactFilterInput
    $searchText: String
  ) {
    contactsCount(
      tenant_id: $tenant_id
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
